import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

// import Header from "../../components/header/Header";

import ErrorBoundary from "../../components/global/error-boundary";
import Header from "../../components/header/index";

const Layout = () => {
  const location = useLocation();
  const prevPathnameRef = useRef();

  useEffect(() => {
    // Check if the pathname has changed
    if (prevPathnameRef.current !== location.pathname) {
      window.scrollTo(0, 0);
    }

    // Update the ref with the current pathname
    prevPathnameRef.current = location.pathname;
  }, [location.pathname]);

  if (process.env.NODE_ENV === "production") {
    return (
      <ErrorBoundary>
        <Header />
        <Outlet />
      </ErrorBoundary>
    );
  }

  // In non-production, render content without ErrorBoundary
  return (
    <>
      <Header />
      <Outlet />
    </>
  );
};

export default Layout;
